import React from 'react';
import { ServiceConnectionMetadataContext, IServiceConnectionMetadataContext } from '../Contexts/ServiceConnectionMetadataContext';

export default function useServiceConnectionMetadata(): IServiceConnectionMetadataContext {
	const context = React.useContext(ServiceConnectionMetadataContext);
	if (!context) {
		throw new Error('useServiceConnectionMetadataContext must be used within a ServiceConnectionMetadataProvider');
	}
	return context;
}
